import type { ReactNode } from 'react';
import React from 'react';
import './index.scss';

export type ComponentProps = {
    children?: ReactNode
};

const Component: React.FC<ComponentProps> = () => {

    return (
        <span className={'flexGrow'}></span>
    );
};
export default Component;
